import { getCollectibleElasticParams } from "@/services/collectibles/elastic/collectiblesElasticHelpers";
import type { PublicCollectionItem } from "@/services/collection/item/public";
import { hasCollectibleElastic, type MarketplaceItem } from "@/services/marketplace/item";
import type { Ref } from "vue";

export function useMarketplaceItemParameters(marketplaceItem: Ref<MarketplaceItem>, collectionItem: Ref<PublicCollectionItem>) {
  const params = computed(() => {
    if (hasCollectibleElastic(marketplaceItem.value)) {
      return getCollectibleElasticParams(marketplaceItem.value.collectibleElastic);
    } else {
      return collectionItem.value.catalogueItemParams.map((param) => ({ name: param.label, value: param.value }));
    }
  });

  return params;
}
